import { addAllToRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  GoalsOrganizationGoalsLoadMoreFulfilledAction,
  GoalsOrganizationLoadByIdAction,
} from '../../domains/goalsOrganizations/actions.types';
import {
  GoalsTeamLoadByIdFulfilledAction,
  GoalsTeamLoadMoreGoalsFulfilledAction,
} from '../../domains/goalsTeams/actions.types';
import { GroupGoalsLoadAction } from '../../domains/groupGoals/actions.types';

import { Goals } from './types';

export const initialState: Goals = {};

type GoalsActions =
  | GroupGoalsLoadAction
  | GoalsOrganizationLoadByIdAction
  | GoalsOrganizationGoalsLoadMoreFulfilledAction
  | GoalsTeamLoadByIdFulfilledAction
  | GoalsTeamLoadMoreGoalsFulfilledAction;

const reducer: Reducer<Goals, GoalsActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_GOALS.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.goals);
    case 'GOALS_ORGANIZATIONS.LOAD_BY_ID_FULFILLED':
      return addAllToRecord(state, action.payload.entities.goals);
    case 'GOALS_TEAMS.LOAD_BY_ID_FULFILLED':
      return addAllToRecord(state, action.payload.entities.goals);
    case 'GOALS_ORGANIZATIONS.LOAD_MORE_GOALS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.goals);
    case 'GOALS_TEAMS.LOAD_MORE_GOALS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.goals);
    default:
      return state;
  }
};

export default reducer;
